import { render, staticRenderFns } from "./user-profession.vue?vue&type=template&id=7450060a&"
import script from "./user-profession.vue?vue&type=script&lang=js&"
export * from "./user-profession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports